import { render, staticRenderFns } from "./ContractRenewal.vue?vue&type=template&id=fd86ad4c&scoped=true"
import script from "./ContractRenewal.vue?vue&type=script&lang=js"
export * from "./ContractRenewal.vue?vue&type=script&lang=js"
import style0 from "./ContractRenewal.vue?vue&type=style&index=0&id=fd86ad4c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd86ad4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd86ad4c')) {
      api.createRecord('fd86ad4c', component.options)
    } else {
      api.reload('fd86ad4c', component.options)
    }
    module.hot.accept("./ContractRenewal.vue?vue&type=template&id=fd86ad4c&scoped=true", function () {
      api.rerender('fd86ad4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/ContractRenewal.vue"
export default component.exports